const transformSurvey = (res) => res;

export default transformSurvey;
